/*

*/
import React from 'react';

const CrossRegularSmdBlackIcon = (props) => {
    const { name = "", size = "s", color = '#333', className = "", spriteName = "", iconName="close-smd-icon" } = props;

    return (
        <svg className={`icon cross-regular-small-black ${className}`} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 1L1 13" stroke="#191B24" strokeWidth="2" strokeLinecap="round"/>
            <path d="M1 1L13 13" stroke="#191B24" strokeWidth="2" strokeLinecap="round"/>
        </svg>        
    )

};

export default CrossRegularSmdBlackIcon
